export const surveyJson = {
  "logo": "data:image/png;base64,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",
  "completedHtml": "<h3>Thank you for your completing the survey!</h3>",
  "showTitle": "true",
  "showQuestionNumbers": "on",
  "showProgressBar": true,
  "widthMode": "responsive",
  "headerView": "advanced",
  "pages": [
    {
      "name": "Strategy",
      "title": "Strategy",
      "description": "Each question is based on a five-point scale with two distinct descriptors.  Select the response that best indicates where you feel your organization is currently performing. Your feedback is confidential and your individual responses will not be shared with anyone in your organization. We appreciate your honest and candid feedback.",
      "elements": [
        {
          "questionId": "1",
          "type": "rating",
          "name": "Q1",
          "shortTitle": "Communicate Reasons Why",
          "title": "It is critical for leadership both to take ownership of trade-off decisions and to communicate the rationale behind those decisions. Ensure that you articulate strategic trade-offs to minimize complexity for employees.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our leaders don't make trade-off decisions or communicate them, so employees are left to determine priorities themselves.",
          "maxRateDescription": "Leaders regularly communicate key trade-off decisions and their rationale for such decisions. This empowers employees to deliver their work in ways that tie to business strategy.",
          "displayMode": "buttons"
        },
        {
          "questionId": "2",
          "type": "rating",
          "name": "Q2",
          "shortTitle": "Design for Alignment",
          "title": "Use strategy and trade-off clarity to inform the best organization choices for your organization and situation. When resources are limited, allocate them based on what matters most.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our organization's choices are not driven by the strategy. Choice misalignment constrains organization performance.",
          "maxRateDescription": "Organization choices are aligned to strategy, which allows for effective use of critical resources, execution of differentiating capabilities, and achievement of results.",
          "displayMode": "buttons"
        },
        {
          "questionId": "3",
          "type": "rating",
          "name": "Q3",
          "shortTitle": "Share Your Strategy",
          "title": "Articulate your strategy clearly and share it with key stakeholders. This enables them to make the organizational choices that support optimal execution and delivery.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our strategy is not clearly or effectively communicated to the organization, leading to misalignment of choices such as how work is done, how resources are structured, and how talent is leveraged.",
          "maxRateDescription": "Our strategy is well-articulated, which helps leaders make effective organizational choices such as how work is done; how resources are structured; what is measured; how talent is selected, developed, and rewarded; and how leaders foster a winning culture.",
          "displayMode": "buttons"
        },
        {
          "questionId": "4",
          "type": "rating",
          "name": "Q4",
          "shortTitle": "Understand Your Stakeholders' Changing Needs",
          "title": "Articulate your key stakeholders' or customers' needs as well as the specific differentiated value you deliver to them.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We do not have a good understanding of stakeholder needs/expectations and to the extent we do know them, we are not focused on meeting their needs short-term or long-term.",
          "maxRateDescription": "We understand our stakeholder requirements and ensure decisions made drive value to address both short-term and long-term success.",
          "displayMode": "buttons"
        },
        {
          "questionId": "5",
          "type": "rating",
          "name": "Q5",
          "shortTitle": "Design From the Outside In",
          "title": "It is critical to continually assess customer needs and experience to ensure long-term viability and success. Align your strategy around a clear and targeted customer experience.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We make design choices based on current organization resource constraints, design limitations, and organization capabilities – not based on what our customer needs.",
          "maxRateDescription": "When making design choices, we first look at the customer to ensure we are aligned with their unique needs. This drives differentiation and value.",
          "displayMode": "buttons"
        },
        {
          "questionId": "6",
          "type": "rating",
          "name": "Q6",
          "shortTitle": "Be Clear on What You Do Not Offer",
          "title": "Articulate your entire strategy, including trade-offs. State clearly what unique value will be offered. Be equally clear about what value will not be offered. This will make it much easier to stay the course and maintain integrity in the face of trade-off decisions.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We have not clearly defined our distinct offerings to customers. It feels like we are trying to do too much, or we are trying to meet too many customer needs.",
          "maxRateDescription": "We are clear on our value offerings and articulate what we will and will not offer. This provides a compass for focused resourcing and organization alignment, which directly impacts profitability.",
          "displayMode": "buttons"
        },
        {
          "questionId": "7",
          "type": "rating",
          "name": "Q7",
          "shortTitle": "Capabilities Enable Strategic Execution",
          "title": "Identify the critical, strategic capabilities your organization requires to successfully implement its strategy and fully leverage the accompanying trade-offs. Make the aligned choices necessary to effectively deliver, resource, and utilize those capabilities.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We strive to be good at many things and we are not the best in class at any one thing.",
          "maxRateDescription": "We have clearly identified our critical capabilities, where we will be 'world-class', and what will allow us to win. We focus our resources unapologetically on these most critical areas.",
          "displayMode": "buttons"
        },
        {
          "questionId": "8",
          "type": "rating",
          "name": "Q8",
          "shortTitle": "Match Capabilities to Strategic Complexity",
          "title": "As strategy becomes more complex, more and more of a leader's time will be spent to ensure that capabilities are both in place and able to deliver on strategy requirements. When your strategy is moving toward delivering ever more complex solutions, define clearly what new or evolved strategic capabilities will be required.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "The environment changes so quickly that we don't have time to ensure we are keeping on pace. It feels like our organization is ill-suited to the demands of the market.",
          "maxRateDescription": "We continuously review our organization's capabilities to ensure we are keeping on top of the marketplace and align investments with our differentiating capabilities.",
          "displayMode": "buttons"
        },
        {
          "questionId": "9",
          "type": "comment",
          "name": "Q9",
          "title": "Please add any comments about your organization's strategy and how well you currently meet these factors."
        },
      ]
    },
    {
      "name": "Work Process",
      "title": "Work Process",
      "description": "Each question is based on a five-point scale with two distinct descriptors.  Select the response that best indicates where you feel your organization is currently performing. Your feedback is confidential and your individual responses will not be shared with anyone in your organization. We appreciate your honest and candid feedback.",
      elements: [
        {
          "questionId": "10",
          "type": "rating",
          "name": "Q10",
          "shortTitle": "Make Your Wins Repeatable",
          "title": "Every aspect of the work should be understood, repeatable, and documented. Make it a priority to define (or redefine) and document the work processes, guidelines, tools, and principles that enable repeatable wins.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We are not deliberately documenting our business processes, practices, and ways of working. We often rely on institutional knowledge and relationships among team members to ensure things are done properly.",
          "maxRateDescription": "We have identified our 'secret sauce' for winning in the marketplace. We protect and enhance this by ensuring our work processes, guidelines, and are in place to ensure consistent performance and predictable delivery.",
          "displayMode": "buttons"
        },
        {
          "questionId": "11",
          "type": "rating",
          "name": "Q11",
          "shortTitle": "Connect the Right People",
          "title": "Make it easy for people to collaborate and share. Design your work process around seamless delivery of business outcomes by ensuring that the right people and teams have access to information.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Some people see information as power and either hold onto it, work in a silo, or share it reluctantly.",
          "maxRateDescription": "We rely on collaborative processes to deliver results. To do this effectively, we ensure people have the information they need and have the tools that allow them to work with the right people to get the job done.",
          "displayMode": "buttons"
        },
        {
          "questionId": "12",
          "type": "rating",
          "name": "Q12",
          "shortTitle": "Appoint a Process Owner",
          "title": "Name an end-to-end process owner for your most critical business processes. Take steps to ensure that this person has the necessary time and resources available to them to fulfill this role effectively.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We are not even sure what our core business processes are, and we certainly have not implemented process owners. We rely on institutional knowledge to execute work, train newcomers, and problem solve performance dips in one-off and ad hoc ways.",
          "maxRateDescription": "Our core business processes have named process owners to ensure there is discipline and accountability in place for effective process delivery and performance. When performance dips, process owners can identify root causes and quickly implement fixes.",
          "displayMode": "buttons"
        },
        {
          "questionId": "13",
          "type": "rating",
          "name": "Q13",
          "shortTitle": "Change Work Processes to Change Results",
          "title": "Intentions alone will not change the work. Your organization design work will not drive change if it's only focused on your organizational charts. To make a difference it must also include an analysis of how the work connects to strategy.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Most organizational changes center on adjusting reporting relationships with limited work changes. We do not have tools or methods for redesigning work activities or where they belong.",
          "maxRateDescription": "If we are making a strategic or an organizational change, we focus first on the work we are and need to be doing to ensure alignment with our strategic intent. We have methods and tools for redesigning and changing how work is done - it is part of our DNA.",
          "displayMode": "buttons"
        },
        {
          "questionId": "14",
          "type": "rating",
          "name": "Q14",
          "shortTitle": "Design for Differentiated Delivery",
          "title": "To differentiate against your competitors, you need more than great products and services; you need different work processes that set you apart. Know your customers and build strongly integrated work processes that meet their needs in just the right way to deliver exceptional value.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We are feeling commoditization pressures, and we spend most of our time and efforts trying to benchmark others in the industry. We are not that distinctive in our marketplace.",
          "maxRateDescription": "We know what differentiates us in the market and we carefully design our work and processes in such a way that these differentiating qualities stand out and provide exceptional value.",
          "displayMode": "buttons"
        },
        {
          "questionId": "15",
          "type": "rating",
          "name": "Q15",
          "shortTitle": "Prioritize Resources Towards Differentiation",
          "title": "Shift resources to the work that will differentiate you in the marketplace. While it is motivating to work on and define your chosen direction and priorities, pay equal time and attention to choosing what not to resource.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Teams in our organization are always asking for more resources. We simply have not taken the time to make tough prioritization decisions to help in the allocation of resources.",
          "maxRateDescription": "We are laser-focused on our strategic priorities and ensure we have the best resources for the work that will create the most differentiation and the best performance. We are transparent about what activities are resourced and why and what activities are not resourced.",
          "displayMode": "buttons"
        },
        {
          "questionId": "16",
          "type": "rating",
          "name": "Q16",
          "shortTitle": "Design Non-Differentiating Work for Efficiency",
          "title": "Work that does not contribute directly to competitive advantage and differentiation should be designed for efficiency, standardization, and lowest cost.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We spend too much time, money, and resources on work that is not differentiating for our organization. We do not have a good idea of what others in our industry are doing so we only seek improvements based on our own internal benchmarks.",
          "maxRateDescription": "We relentlessly look for ways to streamline or automate work activities that do not contribute to our organization's differentiation. Where possible we shift resources to more differentiating activities.",
          "displayMode": "buttons"
        },
        {
          "questionId": "17",
          "type": "rating",
          "name": "Q17",
          "shortTitle": "Less Is More",
          "title": "Less is more. You cannot work strategically on 30 initiatives at a time. Identify and focus on the top three or four major strategic initiatives that will influence your bottom line. This allows you to invest properly in ensuring that the most strategic work is resourced sufficiently.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We spread people too thinly across multiple priorities, which may or may not be the most important. We are not clear on what initiative or work drives the greatest strategic value.",
          "maxRateDescription": "We are relentless about identifying our strategic priorities and focusing our best talent on work that is most strategic.",
          "displayMode": "buttons"
        },
        {
          "questionId": "18",
          "type": "rating",
          "name": "Q18",
          "shortTitle": "Optimize the Whole Work System",
          "title": "Design every part of the system—the process, tools/equipment, technologies, and facilities—for optimal output.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our ever-changing environment influences our work processes, which are not in sync and do not allow for optimal output. We know tools, equipment and technology could be leveraged to our advantage, but we have not taken steps to redesign work or realize these benefits.",
          "maxRateDescription": "We enable our work using tools, equipment, and technology to the greatest extent practical. We have been able to realize better process outcomes and efficiencies because of our efforts to enable, automate and digitize our work.",
          "displayMode": "buttons"
        },
        {
          "questionId": "19",
          "type": "comment",
          "name": "Q19",
          "title": "Please add any comments about how your organization gets work done and how well you currently meet these factors."
        },
      ]
    },
    {
      "name": "Structure & Governance",
      "title": "Structure & Governance",
      "description": "Each question is based on a five-point scale with two distinct descriptors.  Select the response that best indicates where you feel your organization is currently performing. Your feedback is confidential and your individual responses will not be shared with anyone in your organization. We appreciate your honest and candid feedback.",
      elements: [
        {
          "questionId": "20",
          "type": "rating",
          "name": "Q20",
          "shortTitle": "Build Roles and Structures around the Work - Not Vice Versa",
          "title": "Design organization roles and structures to enable the work that needs to be done, not the idiosyncrasies of people and personalities.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Most of our organization structure (org chart) is designed to accommodate the uniqueness of key leaders or historical decisions.",
          "maxRateDescription": "Our organization structure (org chart) is designed/aligned to enable the work that needs to be done.",
          "displayMode": "buttons"
        },
        {
          "questionId": "21",
          "type": "rating",
          "name": "Q21",
          "shortTitle": "Separate Strategic Work from Necessary Work",
          "title": "Identify the work that delivers strategic differentiation and avoid grouping it in roles and structures where non-strategic work is also performed.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Work that drives competitive differentiation is given to roles and structures which also perform non-strategic (transactional) work. There is little separation of strategic from transactional activities.",
          "maxRateDescription": "Work that drives competitive differentiation is grouped into roles and structures that perform little non-strategic (transactional) work. Our organization is focused on the activities that enable differentiation.",
          "displayMode": "buttons"
        },
        {
          "questionId": "22",
          "type": "rating",
          "name": "Q22",
          "shortTitle": "Structure Back-Office Work for Efficiency",
          "title": "Identify the work in the organization which is required but does not deliver strategic differentiation. Drive toward efficiency. Organize people together in centers to drive toward maximum efficiency. Both structure and work come into play here.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Transactional work is generally dispersed/decentralized, has a high degree of variability, and is not performed efficiently.",
          "maxRateDescription": "Transactional, non-differentiating work is grouped/pooled in centers. Most transactional processes are structured for maximum efficiency.",
          "displayMode": "buttons"
        },
        {
          "questionId": "23",
          "type": "rating",
          "name": "Q23",
          "shortTitle": "Don't Copy Your Competitor's Structure",
          "title": "Design organization roles and structures to support the unique strategy and capabilities of the organization.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our structure is generic and does not enable our unique strategy and capabilities or is not distinct from our competitors in any way.",
          "maxRateDescription": "Our structure is intentionally designed to enable our organization's unique strategy and capabilities.",
          "displayMode": "buttons"
        },
        {
          "questionId": "24",
          "type": "rating",
          "name": "Q24",
          "shortTitle": "Consider Virtual Delivery Options for Performing Work",
          "title": "Optimize virtual spaces so the best talent solutions can be sought wherever it's available.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We design our work, find talent, and structure teams locally. We are dependent on physical locations for the performance of work.",
          "maxRateDescription": "We design our work, find talent, and structure teams regardless of physical location by leveraging virtual solutions.",
          "displayMode": "buttons"
        },
        {
          "questionId": "25",
          "type": "rating",
          "name": "Q25",
          "shortTitle": "Design for End-to-end Process Ownership",
          "title": "Organizational boundaries should not inhibit process performance. Build ANCHOR, design structures, linking mechanisms, and/or roles to ensure end-to-end process ownership.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our organizational boundaries inhibit process performance. Structures, roles, or other mechanisms are inadequate in ensuring end-to-end process ownership.",
          "maxRateDescription": "Organizational boundaries do not inhibit process performance. Structures, roles, or other mechanisms are in place to ensure end-to-end process ownership.",
          "displayMode": "buttons"
        },
        {
          "questionId": "26",
          "type": "rating",
          "name": "Q26",
          "shortTitle": "Empower Your Organization from the Bottom up",
          "title": "Push decision making to the lowest level possible to improve the speed of decisions and employee engagement. Clarify governance rights, design guardrails, and guiding principles to maintain alignment to strategic goals and trade-offs.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We have not pushed decision-making to the lowest level possible. Too many management approvals are required or there are no controls in place.",
          "maxRateDescription": "Decision-making has been pushed to the lowest prudent level of the organization. Clear governance and guardrails are in place to ensure decision-making aligns with strategic goals and trade-offs.",
          "displayMode": "buttons"
        },
        {
          "questionId": "27",
          "type": "rating",
          "name": "Q27",
          "shortTitle": "Minimize Role Confusion",
          "title": "Clarify decision rights to accomplish work with the least confusion about who is responsible for what. Minimize escalations for approvals and tie-breaks.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Decisions rights are unclear. When decisions are needed, lots of parties are involved or numerous decisions are escalated up the organizational hierarchy for resolution.",
          "maxRateDescription": "Decision rights are clear. Escalations for approvals and tie-breaks are rarely needed.",
          "displayMode": "buttons"
        },
        {
          "questionId": "28",
          "type": "rating",
          "name": "Q28",
          "shortTitle": "Link across Boundaries",
          "title": "Design ways to link people across organizational boundaries whose work is interdependent.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our organization lacks mechanisms to link people who need to work across organizational boundaries. There is an overreliance on personal relationships or politics to get things done.",
          "maxRateDescription": "Linking mechanisms are in place to connect people who need to work across organizational boundaries. Those mechanisms are adequate for the task at hand.",
          "displayMode": "buttons"
        },
        {
          "questionId": "29",
          "type": "rating",
          "name": "Q29",
          "shortTitle": "Change the Work to Change Results",
          "title": "Do not rely only on changes to reporting relationships and org structure to bring about changes in performance. Review other facets of the cube model.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "When significant performance improvement is needed by the organization, we often rearrange reporting relationships or organizational structures without also changing work processes and other facets of the organization.",
          "maxRateDescription": "When significant performance improvement is needed by the organization, we always think systemically to align all facets of the organization, such as work, structure, metrics, talent, culture, etc.",
          "displayMode": "buttons"
        },
        {
          "questionId": "30",
          "type": "comment",
          "name": "Q30",
          "title": "Please add any comments about your organization's structure and how well you currently meet these factors."
        },
      ]
    },
    {
      "name": "Information & Metrics",
      "title": "Information & Metrics",
      "description": "Each question is based on a five-point scale with two distinct descriptors.  Select the response that best indicates where you feel your organization is currently performing. Your feedback is confidential and your individual responses will not be shared with anyone in your organization. We appreciate your honest and candid feedback.",
      elements: [
        {
          "questionId": "31",
          "type": "rating",
          "name": "Q31",
          "shortTitle": "Enable Decision Making through Information and Insights",
          "title": "Deliver pertinent, easily accessible information to those who need it to make business decisions. Look beyond the raw data or summary statistics to find the analytical insights that can generate a competitive advantage.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We don't have easy access to clean data. We don't do a great job at drawing insights from the data we do have.",
          "maxRateDescription": "We have put systems in place to easily access information and make data-driven decisions.",
          "displayMode": "buttons"
        },
        {
          "questionId": "32",
          "type": "rating",
          "name": "Q32",
          "shortTitle": "Link Metrics and Behaviors",
          "title": "Consider the impact on behaviors when designing metrics. Select measures to reinforce the differentiating behaviors you want and avoid reinforcing behaviors you do not want.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We focus on measuring industry best-practice metrics. However, these are not always in alignment with our organizational goals, so they do not drive the desired behaviors.",
          "maxRateDescription": "We have identified which behaviors are necessary to ensure the delivery of differentiated value and have carefully designed metrics to drive those behaviors.",
          "displayMode": "buttons"
        },
        {
          "questionId": "33",
          "type": "rating",
          "name": "Q33",
          "shortTitle": "Make Performance Visible So It Stays Front and Center",
          "title": "Make organization alignment efforts visible so that strategic priorities stay front and center in the minds of everyone.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We do not regularly publish progress toward strategic initiatives. Leaders are not diligent about using data to drive performance or to make resourcing decisions.",
          "maxRateDescription": "We are transparent with the data that is being used to measure performance, make real-time adjustments, and use this information to ensure optimal performance and resourcing of initiatives.",
          "displayMode": "buttons"
        },
        {
          "questionId": "34",
          "type": "rating",
          "name": "Q34",
          "shortTitle": "Measure the Whole Process, Not Just the Outputs",
          "title": "Design a measurement system that is simple, yet complete. Ensure that not all metrics are focused on the outputs of work efforts – focus also on operational and input metrics.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our metrics focus solely on output metrics which doesn't always give us a complete view of how a process is performing. Leaders tend to fixate on a few key metrics rather than looking at overall performance.",
          "maxRateDescription": "We use a variety of metrics to ensure we are looking at the performance of end-to-end processes (including input, operational, and output measures) to see how we are performing.",
          "displayMode": "buttons"
        },
        {
          "questionId": "35",
          "type": "rating",
          "name": "Q35",
          "shortTitle": "Measure the Critical Few",
          "title": "Focus on the few key measurements that drive leader and employee behaviors aligned to your organization's strategy and culture.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We track many metrics but aren't always sure which metrics are the most important to track or that drive strategic differentiation.",
          "maxRateDescription": "We have determined the critical few things that matter most to measure, and we put our efforts there. This drives the desired performance and behaviors.",
          "displayMode": "buttons"
        },
        {
          "questionId": "36",
          "type": "rating",
          "name": "Q36",
          "shortTitle": "Keep Your Information Safe",
          "title": "Stay vigilant—don't take access to your data for granted. Invest in and design procedures and systems to ensure the safe and secure handling of data and information.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our data isn't fully secure, and we've experienced issues with security threats. Despite this, data is difficult to access and use/analyze.",
          "maxRateDescription": "We've taken steps to ensure our data is secure. We've found a good balance between information security and free access to information for decision-making and performance enhancement.",
          "displayMode": "buttons"
        },
        {
          "questionId": "37",
          "type": "comment",
          "name": "Q37",
          "title": "Please add any comments about how your organization gathers and utilizes information and metrics and how well you currently meet these factors."
        },
      ]
    },
    {
      "name": "People & Rewards",
      "title": "People & Rewards",
      "description": "Each question is based on a five-point scale with two distinct descriptors.  Select the response that best indicates where you feel your organization is currently performing. Your feedback is confidential and your individual responses will not be shared with anyone in your organization. We appreciate your honest and candid feedback.",
      elements: [
        {
          "questionId": "38",
          "type": "rating",
          "name": "Q38",
          "shortTitle": "Find the Right Talent and Skills",
          "title": "Don't limit your organization design to the skills you have today. Determine the skills needed, and plan to hire, train, or outsource those that are missing within your organization.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our organization is built around the talent and skillsets available today. Changes to the organization structure are made to leverage current talent.",
          "maxRateDescription": "Our strategy determines the skill sets we need and our hiring, training, and development processes align with our needs.",
          "displayMode": "buttons"
        },
        {
          "questionId": "39",
          "type": "rating",
          "name": "Q39",
          "shortTitle": "Ensure Selection and Assessment Processes Are Consistent and Fair",
          "title": "Establish and follow legal and ethical processes to assess talent and select the best talent for new roles (even if you are just shifting current organization members into new roles).",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We move talent into new roles in the organization based on a gut-feel assessment, personal experience, and relationships and/or without consideration for the full talent pool available in other parts of the organization.",
          "maxRateDescription": "All talent moves follow a selection and assessment process to ensure moves are fair and the right people are placed in the right roles. Leaders collaborate on moves and export/share top talent regularly to other teams when appropriate.",
          "displayMode": "buttons"
        },
        {
          "questionId": "40",
          "type": "rating",
          "name": "Q40",
          "shortTitle": "Build Top-Notch, Diverse Teams",
          "title": "Be as thoughtful in staffing your organization as you are in designing it. Look for ways to acquire and/or promote top talent while building highly diverse teams that can leverage unique backgrounds, ethnicities, and perspectives.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We are reactive at hiring and tend to select people with similar backgrounds and experiences.",
          "maxRateDescription": "We make it a priority to build teams that have highly diverse backgrounds, ethnicities, and perspectives.",
          "displayMode": "buttons"
        },
        {
          "questionId": "41",
          "type": "rating",
          "name": "Q41",
          "shortTitle": "Align Skill Capabilities with Strategy",
          "title": "Ensure people processes work for you (not the other way around). If necessary, revamp people selection processes, employee development practices, performance management systems, and reward systems so they align with the organization's strategic aims.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our people processes are generic and are adopted inconsistently.",
          "maxRateDescription": "People processes have been built with unique business needs in mind to ensure each area of the business can meet its strategic objectives.",
          "displayMode": "buttons"
        },
        {
          "questionId": "42",
          "type": "rating",
          "name": "Q42",
          "shortTitle": "Design to Your Strategy, Not to Current Competencies and Skills",
          "title": "Understand the delta between your current human capabilities and needed capabilities. Assess and build the critical capabilities required to drive your new strategy. Leverage your current talent but go outside if something else is needed.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We focus on the capabilities we have on hand and ensure we are organized to best leverage them. We will develop workarounds in areas where we do not have the right skillsets.",
          "maxRateDescription": "We keep in mind the human capabilities needed for the future and evaluate against current capabilities to proactively bridge the gap with targeted training, staffing plans, or other human capital programs.",
          "displayMode": "buttons"
        },
        {
          "questionId": "43",
          "type": "rating",
          "name": "Q43",
          "shortTitle": "Link Rewards to Strategic Behaviors and Performance",
          "title": "Design rewards to reinforce the behaviors you want and avoid reinforcing behaviors you do not want.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We have standard reward processes across the organization. Eligibility and reward levels do not vary based on individual work output or behaviors.",
          "maxRateDescription": "We have identified the key behaviors and performance outcomes that we want to achieve. We have built reward systems to reinforce the desired behaviors and performance.",
          "displayMode": "buttons"
        },
        {
          "questionId": "44",
          "type": "comment",
          "name": "Q44",
          "title": "Please add any comments about your organization's hiring and development policies and how well you currently meet these factors."
        },
      ]
    },
    {
      "name": "Continuous Alignment",
      "title": "Continuous Alignment",
      "description": "Each question is based on a five-point scale with two distinct descriptors.  Select the response that best indicates where you feel your organization is currently performing. Your feedback is confidential and your individual responses will not be shared with anyone in your organization. We appreciate your honest and candid feedback.",
      elements: [
        {
          "questionId": "45",
          "type": "rating",
          "name": "Q45",
          "shortTitle": "Make Organizational Improvement a Lifestyle, Not an Event",
          "title": "Keeping the organization in alignment is not a one-and-done event. Make continuous design and alignment part of your organization's DNA – embed it in your culture and operating rhythm.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We make organizational changes and improvements periodically, but we spend most of our time focused on executing day-to-day work. We are reactive, and we do not regularly step back to ensure our organization and systems are running smoothly.",
          "maxRateDescription": "We keep a close eye on our continuously changing environment. We regularly assess gaps, prioritize impacts and opportunities, and make improvements so our organization runs effectively.",
          "displayMode": "buttons"
        },
        {
          "questionId": "46",
          "type": "rating",
          "name": "Q46",
          "shortTitle": "Run Regular Organization Health Checks",
          "title": "Schedule regular health assessments to ensure organizational capabilities are fit for the strategies and priorities of the new year.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We know what has made us successful so there is a limited discipline focused on regularly assessing the effectiveness of our organization. We only address organizational misalignments when a problem happens, or a deficiency emerges.",
          "maxRateDescription": "We perform a regular health check as part of our annual business planning cycle to determine what, if any, changes need to be made to our organization to ensure alignment to drive differentiation and deliver performance objectives. We tackle any misalignments as we reset our priorities.",
          "displayMode": "buttons"
        },
        {
          "questionId": "47",
          "type": "rating",
          "name": "Q47",
          "shortTitle": "Build Renewal Processes and Mechanisms into Your Daily Operations",
          "title": "Adopt a formal continuous alignment approach/methodology to ensure constant organizational renewal, and address gaps that surface.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our organization's processes are not well defined. Leaders are so busy with their day-to-day responsibilities that improvement efforts are led primarily by central group(s) who identify organizational misalignments or performance gaps and spearhead periodic efforts to make improvements.",
          "maxRateDescription": "Our processes are designed in such a way that defects are easily surfaced so corrective action can happen. Our organization has a standard methodology or tool kit for addressing organizational misalignments and performance gaps.",
          "displayMode": "buttons"
        },
        {
          "questionId": "48",
          "type": "rating",
          "name": "Q48",
          "shortTitle": "Place Continuous Alignment Responsibility on the Owner of Daily Operations",
          "title": "Design continuous alignment responsibilities into the jobs and accountabilities of those who perform the work. By grouping continuous alignment responsibilities with ownership of daily operations responsibilities, you will fix misalignments in real-time and accelerate delivery.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our leaders are not motivated to continuously align their processes. Often their teams are already overworked and not eager to make changes or adopt the process discipline that could improve long-term results.",
          "maxRateDescription": "Leaders are held accountable for having a quality mindset and ensuring the processes they own are tweaked on an ongoing, real-time basis as misalignments are recognized.",
          "displayMode": "buttons"
        },
        {
          "questionId": "49",
          "type": "rating",
          "name": "Q49",
          "shortTitle": "Focus on Balancing the Triple Constraints (Cost, Quality, and Speed)",
          "title": "Balance continuous alignment efforts to assess your organization's ability to achieve strategic outcomes in a sustainable way. Measure multiple aspects of performance and have approaches and tools for addressing all types of performance gaps.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We tend to focus improvement efforts primarily on cost containment or reduction. Measures of quality or speed are only sporadically assessed and managed.",
          "maxRateDescription": "Our continuous alignment efforts address all major aspects of performance (cost, quality, and speed) to ensure balanced outcomes and strategic differentiation.",
          "displayMode": "buttons"
        },
        {
          "questionId": "50",
          "type": "comment",
          "name": "Q50",
          "title": "Please add any comments about your organization's continuous alignment strategy and how well you currently meet these factors."
        },
      ]
    },
    {
      "name": "Leadership & Culture",
      "title": "Leadership & Culture",
      "description": "Each question is based on a five-point scale with two distinct descriptors.  Select the response that best indicates where you feel your organization is currently performing. Your feedback is confidential and your individual responses will not be shared with anyone in your organization. We appreciate your honest and candid feedback.",
      elements: [
        {
          "questionId": "51",
          "type": "rating",
          "name": "Q51",
          "shortTitle": "Be Intentional With Your Culture",
          "title": "Identify cultural elements such as values, norms, and behaviors that are strategically important, and measure progress towards them.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Cultural norms emerge organically within each team based on the priorities of the leader. Those norms may not connect to the organization's strategy and culture.",
          "maxRateDescription": "There are clearly defined cultural elements to which all members of our organization buy in and align. Related organization choices (e.g., work processes, hiring practices, performance metrics, organization structures, etc.) reinforce the culture we want and that we believe sets us apart.",
          "displayMode": "buttons"
        },
        {
          "questionId": "52",
          "type": "rating",
          "name": "Q52",
          "shortTitle": "Model the Behavior You Want From Others",
          "title": "Walk the talk. Scrutinize leadership behaviors to ensure they model and reinforce espoused cultural beliefs. Be the change you want from members of the organization.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our leaders often act in ways that are contrary to the expected leadership behaviors, yet no negative action is taken.",
          "maxRateDescription": "Leaders openly model core behaviors, seek feedback, and admit when they make missteps. They hold others accountable to uphold these behaviors as well and ensure they are front and center in the decisions they make.",
          "displayMode": "buttons"
        },
        {
          "questionId": "53",
          "type": "rating",
          "name": "Q53",
          "shortTitle": "Leverage Leaders as Your Culture Champions",
          "title": "Involve people in spreading messages, designing solutions, and implementing changes. Don't just talk to them about culture; help them live it and be a part of it.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Managers are seldom asked for input on decisions that impact culture. Leaders are not positioned to champion our culture.",
          "maxRateDescription": "Managers are empowered to drive cultural change within their teams. They are included in designing solutions and crafting messaging, so it reflects their collective voice.",
          "displayMode": "buttons"
        },
        {
          "questionId": "54",
          "type": "rating",
          "name": "Q54",
          "shortTitle": "Embed Organization Alignment in Your DNA",
          "title": "Encourage a culture where everyone designs all the time. Make organization alignment a regular, ongoing activity—something employees understand and expect.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We are continuously busy making changes, but they seem to be without rhyme or reason. Instead of letting a structure \"stick\", we tend to make knee-jerk reactions if something is not working immediately.",
          "maxRateDescription": "We regularly review and/or tweak our structure to ensure we are aligned to deliver results. Employees are encouraged to share ideas on improvements to better align with the business. We are transparent when changes are made.",
          "displayMode": "buttons"
        },
        {
          "questionId": "55",
          "type": "rating",
          "name": "Q55",
          "shortTitle": "Don't Hide Good Work",
          "title": "Ensure alignment and change efforts are visible and transparent.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We take a big bang approach to organizational changes and those changes are often developed behind closed doors. People can be surprised when changes to their roles, work, or organization are announced.",
          "maxRateDescription": "We share information with associates when organizational elements are being reviewed. We provide information as decisions are made with clear timelines,so people know what to expect.",
          "displayMode": "buttons"
        },
        {
          "questionId": "56",
          "type": "rating",
          "name": "Q56",
          "shortTitle": "Develop Alignment Leader® Competencies",
          "title": "Build Alignment Leader® capabilities throughout your organization.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Leaders are tactical and siloed. They do not (or cannot) step back and take a big-picture look at the organization to make thoughtful decisions. Organizational choices are often disconnected, or trade-offs are not made.",
          "maxRateDescription": "Leaders can make strategic decisions and trade-offs. They understand how organizational choices are connected. They bring others along and build a network of change-agile leaders.",
          "displayMode": "buttons"
        },
        {
          "questionId": "57",
          "type": "comment",
          "name": "Q57",
          "title": "Please add any comments about your organization's leadership and culture and how well you currently meet these factors."
        },
      ]
    },
    {
      "name": "Organization & Alignment",
      "title": "Organization & Alignment",
      "description": "Each question is based on a five-point scale with two distinct descriptors.  Select the response that best indicates where you feel your organization is currently performing. Your feedback is confidential and your individual responses will not be shared with anyone in your organization. We appreciate your honest and candid feedback.",
      elements: [
        {
          "questionId": "58",
          "type": "rating",
          "name": "Q58",
          "shortTitle": "Get on the Balcony",
          "title": "Approach organization alignment from the big-picture view of your organization. Be sure you understand how choices in one part of the organization will impact other parts.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our senior leaders mostly focus on running the business. They rarely have the capacity or time to step back and address strategic or transformational issues.",
          "maxRateDescription": "Our senior leaders spend most of their time on the strategic and transformational issues of the business. They trust middle-level management to handle running the business.",
          "displayMode": "buttons"
        },
        {
          "questionId": "59",
          "type": "rating",
          "name": "Q59",
          "shortTitle": "Keep an Eye on the Market (Change Is a Constant)",
          "title": "Monitor changes in the market and ensure your organization has systems and processes in place for incorporating and addressing new requirements.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Most organizational changes are made in response to internal drivers or in reaction to threats encroaching on our current operations and performance. We have limited mechanisms to assess or provide insights into where the market is heading.",
          "maxRateDescription": "The market is ever-changing. We do a great job of keeping an eye on the external environment and anticipating the needed organizational changes to keep pace with customers, markets, technology, and regulatory changes.",
          "displayMode": "buttons"
        },
        {
          "questionId": "60",
          "type": "rating",
          "name": "Q60",
          "shortTitle": "Strive for Aligned Choices, Not Best Practices",
          "title": "Strive for aligned organization choices over misaligned best practices.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We spend time benchmarking with others in the industry to make sure we are implementing best practices. We can confidently say we have implemented industry best practices. However, we do not do a good job connecting the dots to ensure they are driving our strategy and differentiation.",
          "maxRateDescription": "We take steps to ensure the organizational choices we make are truly aligned across the organization and deliver the intended results - regardless of what the prevailing industry practice may be.",
          "displayMode": "buttons"
        },
        {
          "questionId": "61",
          "type": "rating",
          "name": "Q61",
          "shortTitle": "Encourage Organization Alignment at Every Level of the Organization",
          "title": "Engage leaders and employees throughout the organization, not just at the top.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our C-suite leaders are focused on ensuring organizational alignment, but these decisions do not always trickle down to the right levels in the organization. Other organization members tend to sit back and wait for direction without proactively addressing organizational misalignments.",
          "maxRateDescription": "Everyone is empowered to make choices or recommend changes when they see activities, structures, roles, metrics, or systems that do not align with our strategy.",
          "displayMode": "buttons"
        },
        {
          "questionId": "62",
          "type": "rating",
          "name": "Q62",
          "shortTitle": "Build Organization Alignment Capabilities in Others",
          "title": "In the spirit of “pay it forward,” make sure that alignment thinking permeates your organization and the thinking of organization members.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Only a few leaders or organization members are capable of strategically reviewing the organizational alignment of the business. This capability is not prevalent in our leadership team or company.",
          "maxRateDescription": "Our leaders teach others in the organization how to make organization alignment decisions. They consider organizational alignment skills and experience as key aspects of effective leadership.",
          "displayMode": "buttons"
        },
        {
          "questionId": "63",
          "type": "rating",
          "name": "Q63",
          "shortTitle": "Facilitate a Change in Thinking",
          "title": "Involve organization members in the alignment process. This will accelerate changes in thinking (and thus performance) and ensure those closest to the work and to the customer help inform decision-making.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Our leaders embrace their role as decision-makers and tend to take the lead in making most organization alignment decisions. Because decisions are made in small groups or behind closed doors, change management efforts are significant.",
          "maxRateDescription": "We involve many team members when making organizational changes. This allows people to fully examine design choices and understand how the organization needs must change its behaviors and thinking.",
          "displayMode": "buttons"
        },
        {
          "questionId": "64",
          "type": "comment",
          "name": "Q64",
          "title": "Please add any comments about how aligned your organization is to its strategy and how well you currently meet these factors."
        },
      ]
    },
    {
      "name": "Guiding Transformation",
      "title": "Guiding Transformation",
      "description": "Each question is based on a five-point scale with two distinct descriptors.  Select the response that best indicates where you feel your organization is currently performing. Your feedback is confidential and your individual responses will not be shared with anyone in your organization. We appreciate your honest and candid feedback.",
      elements: [
        {
          "questionId": "65",
          "type": "rating",
          "name": "Q65",
          "shortTitle": "Take an Agile Approach to Transformation",
          "title": "Break your transformation into manageable pieces, and work in sprints so that interim deliverables can be achieved along the way. You do not have to finish the design and transformation to begin working in the future state.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We tend to wait until everything is fully baked to communicate and execute a plan. We may talk about having an agile mindset, but in practice, we do not practice agile ways of working.",
          "maxRateDescription": "We have explicitly embraced agile ways of enabling organization alignment and transformation where it fits the needs of our business. We have the needed support mechanisms, training, and practices to enable agile ways of working.",
          "displayMode": "buttons"
        },
        {
          "questionId": "66",
          "type": "rating",
          "name": "Q66",
          "shortTitle": "Follow a Proven Approach",
          "title": "Use a systematic approach or methodology (like the Cube model) that is proven, repeatable, and scalable.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We don't have a standard approach or philosophy for aligning our organization or driving change. We end up using whatever approach makes sense at the time or base choices on whatever consultants recommend.",
          "maxRateDescription": "We have and use a consistent approach for facilitating organization alignment and transformation work. Leaders and practitioners alike are well-versed in this approach. We can see tangible benefits by following our approach.",
          "displayMode": "buttons"
        },
        {
          "questionId": "67",
          "type": "rating",
          "name": "Q67",
          "shortTitle": "Be Clear on the \"What\" and the \"Why\"",
          "title": "Understand how capable your organization is to deliver strategy, then define where you want to go.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We are more focused on what needs to change without a clear understanding of why or how the change will enable overall strategic improvement for the organization.",
          "maxRateDescription": "When embarking upon a transformation effort, we start by defining the 'why' to ensure we have a compelling case for change.",
          "displayMode": "buttons"
        },
        {
          "questionId": "68",
          "type": "rating",
          "name": "Q68",
          "shortTitle": "Prepare Your Leaders to Lead",
          "title": "Understand how the transformation will impact you as a leader and your peers. Make sure you know what your place is in the redesigned organization.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We provide little time for leaders to embrace and understand the change at hand. We unveil individual impacts at the very end of the process. It is tough for our leaders to integrate the changes into the current ways their teams are working.",
          "maxRateDescription": "We provide space for leaders to fully understand the change and the impact on them personally, their peers, and their teams before enlisting them in leading through the change.",
          "displayMode": "buttons"
        },
        {
          "questionId": "69",
          "type": "rating",
          "name": "Q69",
          "shortTitle": "Get Everyone On Board for the Transformation Journey",
          "title": "Be very intentional about how you will engage the organization so people will make the journey with you. Recognize that people will move at different paces. Over-communicate. Transparency is appreciated even if it generates concern among organization members. If the timing is not right for full transparency, then at least share the timeline and when more information or answers will be available.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We typically roll out changes in large cascade events with leaders finding out at the same time as or just before their team members. There is little prep time for organization members to absorb the implications of the change, ask questions, and provide feedback.",
          "maxRateDescription": "We create talking points for leaders and enroll them in the changes to ensure they fully understand prior to rolling out changes so they can help with communications and change management.",
          "displayMode": "buttons"
        },
        {
          "questionId": "70",
          "type": "rating",
          "name": "Q70",
          "shortTitle": "Track Your Progress along the Journey",
          "title": "You get what you measure. At the outset find the vision for the journey. Set clear goals and objectives, then develop and monitor transformation metrics that enable you to clearly articulate your progress to the desired future state.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "We do not measure the success (or failure) of our transformation and alignment efforts. Often, we ask a working manager/leader to take responsibility for leading transformation efforts alongside their day jobs.",
          "maxRateDescription": "For any transformation efforts, we begin with the end in mind, set clear goals, and assign key performance indicators for the work ahead. We assign someone to lead the project, track milestones, and keep the team on track and accountable.",
          "displayMode": "buttons"
        },
        {
          "questionId": "71",
          "type": "rating",
          "name": "Q71",
          "shortTitle": "Prioritize Investments Using the Lens of Strategy",
          "title": "Prioritize IT investments with a clear sense of the strategic impact. Design organizational solutions that integrate the technical and human elements.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Large investments are often made in silos by leaders without considering broader impact or strategic linkages. Organizational and people enablers are rarely considered as part of designing and implementing large investments (e.g., IT systems, expansion of physical facilities, new processes, etc.).",
          "maxRateDescription": "When we make large investments to transform the way work is done, we make sure that these investments are aligned with our strategic priorities. We also work to align these investments with our organizational and human systems to ensure we get the full impact of our investments.",
          "displayMode": "buttons"
        },
        {
          "questionId": "72",
          "type": "rating",
          "name": "Q72",
          "shortTitle": "Don't Sprint the Marathon",
          "title": "Take care of yourself and encourage others to do so as well. Consider building personal and professional wellness into your change management plans.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Change is hard and we often require stakeholders to 'power through' to ensure we meet deadlines. This leads to burnout and attrition just to meet deadlines, as well as a loss in the enthusiasm for the change.",
          "maxRateDescription": "We understand that organizational alignment efforts and transformations can be taxing/ We consistently strive to ensure professional and personal wellness is maintained throughout the effort.",
          "displayMode": "buttons"
        },
        {
          "questionId": "73",
          "type": "rating",
          "name": "Q73",
          "shortTitle": "Plan for Set-Backs – They Are Going to Happen",
          "title": "Don't get shaken by speed bumps. Anticipate and have a plan for dealing with setbacks.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "When things go off track, we often see finger-pointing, blaming, and second-guessing about the transformation, as well as about peoples' intentions and efforts.",
          "maxRateDescription": "We understand that things can go wrong or we can experience setbacks. We continuously troubleshoot to see where risks are and build plans to mitigate them should they occur.",
          "displayMode": "buttons"
        },
        {
          "questionId": "74",
          "type": "rating",
          "name": "Q74",
          "shortTitle": "Keep the Tone Positive",
          "title": "Keep the transformation journey in a positive light. Build on positives instead of just working on what is broken. Look for quick, visible wins, and celebrate successes along the way. Simply understanding the reason for a setback helps keep spirits up and can even trigger employees to rally together to overcome the challenge.",
          "isRequired": true,
          "autoGenerate": false,
          "rateValues": [
            {
              "value": 1,
              "text": "1"
            },
            {
              "value": 2,
              "text": "2"
            },
            {
              "value": 3,
              "text": "3"
            },
            {
              "value": 4,
              "text": "4"
            },
            {
              "value": 5,
              "text": "5"
            }
          ],
          "rateMin": 1,
          "minRateDescription": "Some of our leaders are openly against organizational alignment efforts and seem to find reasons for why things won't work. When successes or milestones do occur, they downplay them.",
          "maxRateDescription": "We celebrate successes and milestones and feel motivated to push forward despite setbacks.",
          "displayMode": "buttons"
        },
        {
          "questionId": "75",
          "type": "comment",
          "name": "Q75",
          "title": "Please add any comments about how your organization handles transformations and how well you currently meet these factors."
        }
      ],
    }
  ]
};